import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import ErrorState from '../states/error.state';
import { V1Error } from '../../services/mqtt/v1/v1Errors';

interface ErrorData {
    [key: string]: any;
}

const initialState: ErrorState = {
    data: {},
    v1: [],
    loading: false,
    error: null,
};

const errorSlice = createSlice({
    name: 'error',
    initialState,
    reducers: {
        setErrorData: (state, action: PayloadAction<ErrorData>) => {
            return {
                ...state,
                data: action.payload
            };
        },
        resetErrorData: (state) => {
            return {
                ...state,
                data: {},
                v1: [],
            };
        },
        /** A V1 / Coldfire spa's active faults, decoded; V2 keeps its keyed `data`. */
        setV1ErrorData: (state, action: PayloadAction<V1Error[]>) => {
            return {
                ...state,
                v1: action.payload,
            };
        },
    },
});

export const { setErrorData, resetErrorData, setV1ErrorData } = errorSlice.actions;
export default errorSlice.reducer;
